

export const frontend_url_ref = 'https://nexatrade.uk/signup/'

export const backend_url = 'https://backendapi.nexatrade.uk/'
// 'https://qsdt9zhm-7234.inc1.devtunnels.ms/'

export const explorer_url = 'https://bscscan.com/tx/'

